/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const ClocksIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / clocks</title>
            <defs>
                <path id="a000" d="M0 37h27V0H0z" />
            </defs>
            <g transform="translate(10 5)" fill="none" fillRule="evenodd">
                <path d="M13.5 2C19.85 2 25 7.15 25 13.5S19.85 25 13.5 25 2 19.85 2 13.5 7.15 2 13.5 2zm0 1C7.71 3 3 7.71 3 13.5S7.71 24 13.5 24 24 19.29 24 13.5 19.29 3 13.5 3z" fill="#FCA61B" />
                <mask id="b000" fill="#fff">
                    <use xlinkHref="#a000" />
                </mask>
                <path fill="#FCA61B" mask="url(#b000)" d="M13 14h1V7h-1M14 14h4v-1h-4" />
                <path d="M16.5 32.5c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z" stroke="#FCA61B" mask="url(#b000)" />
                <path fill="#FCA61B" mask="url(#b000)" d="M13 30h1v-3h-1M24 0H3C1.343 0 0 1.343 0 3v21c0 1.657 1.343 3 3 3h21c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3m0 1c1.103 0 2 .897 2 2v21c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h21M22 37h1V27h-1M4 37h1V27H4" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Clocks.tsx